import React, { useState, useRef } from 'react';
import { Field, useFormikContext } from 'formik';
import { Typography, InputAdornment, Backdrop, CircularProgress, FormControl, FormHelperText } from '@mui/material';
import { Schedule, PhoneIphone, MarkEmailUnread } from '@mui/icons-material';
import { TextField } from '@fnol/library/src/components';
import { checkIfSerbianPhoneNumber } from '@fnol/library/src/lib';
import { useApi } from '@fnol/library/src/hooks';
import { translations } from '../../lib/consts';
import { sendOneTimePassword } from '../../rpc/actions';
import './notifications.css';

type Props = {
    tempId: string;
};

const UserNotificationScreen = ({ tempId }: Props) => {
    const { values, touched, errors, setFieldValue } = useFormikContext<any>();

    const Ref = useRef(0);
    const [timer, setTimer] = useState('02:00');
    const getTimeRemaining = (e: any) => {
        const total = Date.parse(e) - Date.parse(new Date().toString());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total,
            minutes,
            seconds,
        };
    };
    const startTimer = (e: any) => {
        const { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            setTimer((minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds));
        }
    };
    const clearTimer = (e: any) => {
        if (Ref.current) window.clearInterval(Ref.current);
        const id = window.setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };
    const getDeadTime = () => {
        const deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + 120);
        return deadline;
    };

    const data = new FormData();
    const { response: pass, fetchMethod: sendPassword } = useApi(
        () => sendOneTimePassword(data),
        () => clearTimer(getDeadTime()),
    );

    const handleSubmit = (email: boolean) => {
        if (!pass.isLoading) {
            data.append('stetaTempid', tempId);
            data.append('kontakt', `${email ? values.submitterEmail : values.submitterPhone}`);
            data.append('slanjeEmail', `${email}`);
            setFieldValue('tempPassContact', email ? values.submitterEmail : values.submitterPhone);
            sendPassword();
        }
    };

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={pass.isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Typography>{translations.userNotification.CONFIRMATION_OF_APPLICANT}</Typography>
            <Typography variant="caption">{translations.userNotification.RECIEVE_MESSAGE}</Typography>
            <div className="icons-wrapper">
                {checkIfSerbianPhoneNumber(values.submitterPhone) && (
                    <div onClick={() => handleSubmit(false)} className="notifications">
                        <Typography>{translations.userNotification.SMS}</Typography>
                        <PhoneIphone />
                    </div>
                )}

                <div onClick={() => handleSubmit(true)} className="notifications">
                    <Typography>{translations.userNotification.EMAIL}</Typography>
                    <MarkEmailUnread />
                </div>
            </div>
            {pass.isSuccess && (
                <Typography className="confirmation-message">{translations.userNotification.MSG_SENT}</Typography>
            )}
            <FormControl>
                <Field
                    name="oneTimePass"
                    placeholder={translations.userNotification.ONE_TIME_PASS}
                    as={TextField}
                    disabled={!pass.isSuccess || timer === '00:00'}
                    error={touched.oneTimePass && errors.oneTimePass}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Schedule color="primary" sx={{ marginRight: '5px' }} />
                                <h3>{timer}</h3>
                            </InputAdornment>
                        ),
                    }}
                />
                {touched.oneTimePass && errors.oneTimePass ? (
                    <FormHelperText error={true}>
                        <>{errors.oneTimePass}</>
                    </FormHelperText>
                ) : null}
            </FormControl>
        </>
    );
};

export default UserNotificationScreen;
